module.exports = __webpack_public_path__ + "media/images/star-eade9fc49ca060041df4ebd238e00add.png";